/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApplicationConfig, importProvidersFrom, APP_INITIALIZER, isDevMode } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  HttpBackend,
  HttpClient,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import { tokenInterceptor } from './interceptors/token.interceptor';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import {  registerLocaleData } from '@angular/common';
import {authInterceptor } from './interceptors/auth.interceptor';
import localeIt from '@angular/common/locales/it';
import localeEn from '@angular/common/locales/en';
import { MappingService } from './services/mapping.service';
import { Observable } from 'rxjs';
import { provideServiceWorker } from '@angular/service-worker';
function initializeMappings(mappingService: MappingService): () => Observable<any> {
  return () => mappingService.loadMappings();
}

export function detectDefaultLanguage() {
  const browserLang = navigator.language;
  if (browserLang.startsWith('it')) {
    return 'it';
  } else if (browserLang.startsWith('en')) {
    return 'en';
  } else {
    return 'en';
  }
}

registerLocaleData(localeIt);
registerLocaleData(localeEn);

export function HttpLoaderFactory(httpHandler: HttpBackend): TranslateHttpLoader {
  return new TranslateHttpLoader(new HttpClient(httpHandler),'../assets/i18n/', '.json');
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimationsAsync(),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([authInterceptor, tokenInterceptor])),
    importProvidersFrom(TranslateModule.forRoot({
        defaultLanguage: detectDefaultLanguage(),
        loader: {
            provide: TranslateLoader,
            useFactory: HttpLoaderFactory,
            deps: [HttpBackend],
        },
    })),
    {
        provide: APP_INITIALIZER,
        useFactory: initializeMappings,
        deps: [MappingService],
        multi: true,
    },
    provideServiceWorker('ngsw-worker.js', {
        enabled: !isDevMode(),
        registrationStrategy: 'registerWhenStable:30000'
    })
],
};
